import { Box, IconButton, Tooltip, Typography } from '@mui/material'
import React from 'react'
import { useDownloadAttachment } from '../../api/aws/comments/useDownloadAttachments'
import GetAppIcon from '@mui/icons-material/GetApp'
import DeleteIcon from '@mui/icons-material/Delete'

interface Attachment {
  id: string
  iconLink: string
  mimeType: string
  name: string
  thumbnailLink: string
  url: string
}

interface RenderThumbnailProps {
  attachment: Attachment
  onOpenViewer: (index: number) => void
  onDeleteAttachment: (index: number) => void
  getThumbnail: (attachment: Attachment) => React.ReactElement

  attachmentIndex: number
  isNoteCreator: boolean
}

const RenderThumbnail: React.FC<RenderThumbnailProps> = ({
  attachment,
  attachmentIndex,
  onDeleteAttachment,
  onOpenViewer,
  getThumbnail,
  isNoteCreator,
}) => {
  const { downloadAttachment } = useDownloadAttachment()
  return (
    <Tooltip
      key={attachment.url}
      placement="top"
      title={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" noWrap sx={{ maxWidth: 200 }}>
            {attachment.name}
          </Typography>
          {isNoteCreator && (
            <IconButton
              size="small"
              sx={{ color: '#fff' }}
              onClick={e => {
                e.stopPropagation()
                onDeleteAttachment(attachmentIndex)
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          )}

          <IconButton
            size="small"
            sx={{ color: '#fff' }}
            onClick={e => {
              e.stopPropagation()
              downloadAttachment(attachment.url, attachment.name)
            }}
          >
            <GetAppIcon fontSize="small" />
          </IconButton>
        </Box>
      }
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: 'background.default',
            color: 'text.primary',
            p: 1,
            borderRadius: 1,
          },
        },
      }}
    >
      <Box
        onClick={() => onOpenViewer(attachmentIndex)}
        sx={{
          width: attachment.mimeType === 'application/pdf' ? 140 : 24,
          height: attachment.mimeType === 'application/pdf' ? 180 : 24,
          mx: 0.5,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: 1,
          overflow: 'hidden',
          cursor: 'pointer',
          transition: 'transform 0.3s ease',
          '&:hover': {
            transform: 'scale(1.11)',
          },
        }}
      >
        {getThumbnail(attachment)}
      </Box>
    </Tooltip>
  )
}

export default RenderThumbnail
